import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isFlexible, isMetal, isRigid } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidMinPattern = (values: EstimateValues, minPattern?: string) => {
  switch (minPattern) {
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.030mm"].value:
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.050mm"].value:
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.060mm"].value:
      return isFlexible(values)
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.075mm"].value:
      return isRigid(values) || isFlexible(values)
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.10mm"].value:
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.127mm"].value:
      return true
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.15mm"].value:
      return isRigid(values) || isMetal(values)
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.20mm"].value:
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.25mm"].value:
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.30mm"].value:
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.35mm"].value:
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.40mm"].value:
      return isRigid(values)
    default:
      return false
  }
}

export default isValidMinPattern
